import React, { useEffect, useMemo, useState } from "react";
import { ServiceProviderId } from "../../../../../domain/service_provider/ServiceProviderId";
import { Loading } from "../../../common/Loading";
import { InputSelectBox, InputSelectBoxParams } from "../../../common/input/InputSelectBox";
import { LabelValueSet } from "../../../../../domain/utility/LabelValueSet";
import { useServiceProviderList } from "../../../../hooks/admin/service_provider/useServiceProviderList";
import { useAppDispatch } from "../../../../../state/store";
import { getServiceProviderListAction } from "../../../../../state/usecase/admin/service_provider/actions";

export const ServiceProviderSelector = React.memo(function ServiceProviderSelector(props: ServiceProviderSelectorProps) {
    const { isNullable, whenServiceProviderChanged, hasError } = props;

    const dispatch = useAppDispatch();

    const serviceProviders = useServiceProviderList();

    const [currentServiceProviderId, setCurrentServiceProviderId] = useState(props.currentServiceProviderId?.value || "");

    useEffect(() => {
        dispatch(getServiceProviderListAction());
    }, [dispatch]);

    const values: LabelValueSet[] = useMemo(() => (
        serviceProviders?.map((sp) => new LabelValueSet(sp.name.value, sp.id.value)) ?? []
    ), [serviceProviders]);

    if (isNullable !== false) {
        values.unshift(new LabelValueSet("- 未選択 -", ""));
    }

    const inputProps: InputSelectBoxParams = useMemo(() => ({
        value: currentServiceProviderId,
        list: values,
        handleSelectBoxChanged: (value: string) => {
            setCurrentServiceProviderId(value);
            const id = value ? ServiceProviderId.fromString(value) : null;
            whenServiceProviderChanged(id);
        },
        hasError: hasError
    }), [currentServiceProviderId, values, whenServiceProviderChanged, hasError]);

    if (!serviceProviders) return <Loading />;

    return (
        <div>
            <InputSelectBox {...inputProps}/>
        </div>
    );
});

export type ServiceProviderSelectorProps = {
    currentServiceProviderId: ServiceProviderId | null,
    isNullable?: boolean,
    whenServiceProviderChanged: (serviceProviderId: ServiceProviderId | null) => void;
    hasError?: boolean
};
